import {Injectable} from "@angular/core";
import {CrudService} from "./interfaces/crud-service.interface";
import {PushNotificationTemplate} from "../../dto/templates/html-template";
import {HttpClient} from "@angular/common/http";
import {Observable} from "rxjs";
import {DataListModel} from "../../models/data-list-model";
import {EmailTemplate} from "../../dto/templates/email-template";
import {HtmlTemplateVar} from "../../dto/templates/html-template-var";

@Injectable()
export class PushNotificationTemplatesService implements CrudService<PushNotificationTemplate> {

  readonly apiPath = "push-notification-templates/";

  constructor(
    private http: HttpClient,
  ) {
  }

  getMany(): Observable<DataListModel<PushNotificationTemplate>> {
    return this.http.get(this.apiPath) as Observable<DataListModel<PushNotificationTemplate>>;
  }

  get(id: number): Observable<PushNotificationTemplate> {
    return this.http.get(this.apiPath + id) as Observable<PushNotificationTemplate>;
  }

  getVars(): Observable<DataListModel<HtmlTemplateVar>> {
    return this.http.get(this.apiPath + "vars") as Observable<DataListModel<HtmlTemplateVar>>;
  }

  add(item: PushNotificationTemplate): Observable<number> {
    return this.http.post(this.apiPath, item) as Observable<number>;
  }

  update(id: number, item: PushNotificationTemplate): Observable<Object> {
    return this.http.put(this.apiPath + id, item);
  }

  delete(id: number): Observable<Object> {
    return this.http.delete(this.apiPath + id);
  }

  restore(id: number): Observable<Object> {
    return this.http.patch(this.apiPath + id, null);
  }

  deleteMany(list: number[]): Observable<Object> {
    throw new Error("Method not implemented.");
  }

  restoreMany(list: number[]): Observable<Object> {
    throw new Error("Method not implemented.");
  }

  copy(id: number): Observable<number> {
    return this.http.post(this.apiPath + id + '/copy', {oh:1}) as Observable<number>;
  }

}
